import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { createStructuredSelector } from 'reselect'
import { withRouter } from 'react-router-dom'

import { Trans } from '@lingui/macro'
import { Aside, StyledLink, Label } from './styled'
import {
  makeSelectOffers,
  makeSelectHideRenewalPage,
} from 'pages/Renewal/selectors'
import { selectCurrentMemberID } from 'modules/members/selectors'
import { hideRenewalPage } from 'pages/Renewal/actions'
import appUrls from '../urls'
import { selectIsCSMeter, selectIsConsolidatedMember, selectIsBatteryCustomer } from 'modules/members/selectors'

const Sidebar = ({
  offers,
  toggleRenewalPage,
  hideRenewalPage,
  memberID,
  isCSMeter,
  isConsolidatedMember,
  isBatteryCustomer,
  hide = false,
}) => {
  const [urls, setUrls] = useState(appUrls)

  useEffect(() => {
    // hide renewal offer page on sidebar for 24hr after submit date
    const renewTimes = JSON.parse(
      localStorage.getItem('renewal_offer_submit_date')
    )
    var item
    if (renewTimes) {
      item = renewTimes[memberID]
    }
    if (item) {
      let now = new Date().getTime()
      const msBetweenDates = Math.abs(item - now)
      const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000)
      if (hoursBetweenDates < 24) {
        toggleRenewalPage(true)
      } else {
        toggleRenewalPage(false)
        delete renewTimes[memberID]
        localStorage.setItem(
          'renewal_offer_submit_date',
          JSON.stringify(renewTimes)
        )
      }
    } else {
      toggleRenewalPage(false)
    }
  }, [memberID])

  useEffect(() => {
    // enable renewal page based on renewale offers availability
    let tmp = appUrls
      .map(key => {
        if (key.label === 'Renewal') {
          key.isPermitted = offers.length > 0 && hideRenewalPage === false
        }
        return key
      })
      .filter(url => {
        return !url.hideOnDesktop
      })
    setUrls(tmp)
  }, [offers, hideRenewalPage])

  return (
    <>
      {!hide && (
        <Aside data-testid="sideBar">
          {urls.map(({ label, to, exact, Icon, isPermitted, showLink }) => {
            return (isPermitted === false || (showLink && !showLink({ isCSMeter, isConsolidatedMember, isBatteryCustomer }))) ? null : (
              <StyledLink
                data-testid={`sidebarLink:${label}`}
                key={to}
                to={to}
                exact={exact}
              >
                <Icon />
                <Label>
                  <Trans id={label} />
                </Label>
              </StyledLink>
            )
          })}
        </Aside>
      )}
    </>
  )
}

Sidebar.propTypes = {
  offers: PropTypes.array.isRequired,
  hide: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
  offers: makeSelectOffers(),
  hideRenewalPage: makeSelectHideRenewalPage(),
  memberID: selectCurrentMemberID,
  isCSMeter: selectIsCSMeter,
  isConsolidatedMember: selectIsConsolidatedMember,
  isBatteryCustomer: selectIsBatteryCustomer,
})

const mapDispatchToProps = {
  toggleRenewalPage: hideRenewalPage,
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Sidebar)
